(function() {
  function updateSubmitBtnText() {
    $(document).on('change', '#select-how-complete-order', function(e) {
      const $elm = $(e.currentTarget);
      if($elm.val() === 'Email my quote') {
        $('#submitRFQForm').val('Submit quote');
      } else {
        $('#submitRFQForm').val('Submit order request');
      }
    });
  }

  function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  function updateGSTPriceRFQ() {
    const $rqfTable = $('.rfq-table');
    let totalGstPrice = 0;

    $rqfTable.find('tr').each(function(_, elm) {
      const $elm = $(elm);
      const itemQuantity = parseInt($elm.find('.item_qty').val());
      const $priceCol = $elm.find('.td_price');
      const $subTotalCol = $elm.find('.td_subtotal');
      let gstPrice = 0;
      let gstSubTotalPrice = 0;
      let originalSubTotalPrice = 0;

      const originalPrice = $priceCol.find('.money').data('price') || 0;
      gstPrice = originalPrice < 2000 ? originalPrice * 1.099 : originalPrice * 1.1;

      gstPrice = parseInt(Math.round(gstPrice)) || 0;
      gstSubTotalPrice = gstPrice * itemQuantity || 0;
      originalSubTotalPrice = originalPrice * itemQuantity || 0;

      $priceCol.find('.money').attr('data-original-price', originalPrice);
      $priceCol.find('.money').attr('data-price', gstPrice);

      $subTotalCol.find('.money').attr('data-original-price', originalSubTotalPrice);
      $subTotalCol.find('.money').attr('data-price', gstSubTotalPrice);

      const gstPriceText = '$' + (gstPrice / 100).toFixed(2).replace('.00', '');
      $priceCol.find('.money').text(gstPriceText);

      const gstSubTotalPriceText = '$' + (gstSubTotalPrice / 100).toFixed(2).replace('.00', '');
      $subTotalCol.find('.money').text(gstSubTotalPriceText);

      totalGstPrice += gstSubTotalPrice;
    });

    $('.rfq-total').text('$' + (totalGstPrice / 100).toFixed(2).replace('.00', ''));
  };

  function handleGSTPriceRFQPage() {
    const $rqfTable = $('.rfq-table');
    const $quantityBtn = $rqfTable.find('.td_qty').find('input[type="button"]');

    updateGSTPriceRFQ();

    $quantityBtn.on('click', function(evt) {
      evt.preventDefault();
      setTimeout(function() {
        updateGSTPriceRFQ()
      }, 100);
    });
  }

  function handleAfterSubmit() {
    $('.rfq_form_page').on('DOMSubtreeModified', function() {
      const $cta = $('.rfq-success-message').next('.btn');
      if($cta.length) {
        $cta.attr('href', '/pages/stockists');
        $cta.hide();
      }
      buildSuccessMessage();
    });
  }

  const optionInfo = window.optionsRfq || [];

  function buildOption(item) {
    const optionHtml = `
      <div class="option-custom">
        <div class="option-custom__status">
          <span class="option-custom__check">
            <span class="icon-check"></span>
          </span>
        </div>
        <div class="option-custom__title">
          <span class="option-custom__icon">${item.icon}</span>
          <span class="option-custom__value">${item.title}</span>
        </div>
        <div class="option-custom__desc">${item.desc}</div>
      </div>
    `;
    return optionHtml;
  }

  function buildListHtml() {
    // hide original select dropdown
    $('.rfq-container .rfq_form select').addClass('should-hidden');

    let listHtml = '';
    $('#select-how-complete-order').find('option').each(function(idx, elm) {
      const $elm = $(elm);
      const elmVal = $elm.val();
      listHtml += buildOption(optionInfo[idx]);
    });
    $('.select-how-complete-order').append(`<div class="list-option-custom">${listHtml}</div>`);
    $('.select-how-complete-order').find('.option-custom').first().addClass('checked');
  }

  function buildSuccessMessage() {
    const wrapperHtml = `
      <a class="list-step" href="/pages/stockists">
        <span class="list-step__title">Quote successfully submitted</span>
      </a>
    `;
    if($('.list-step').length) {
      return;
    } else {
      $('.rfq-success-message').append(wrapperHtml);
    }
  }

  function handleChangeSelect() {
    $(document).on('click', '.option-custom', function(e) {
      const $elm = $(e.currentTarget);
      $('.option-custom').removeClass('checked');
      $elm.addClass('checked');
      const selectedVal =  $elm.find('.option-custom__value').text();
      $('#select-how-complete-order').val(selectedVal).trigger('change');;
    });
  }

  async function getDataOfQuote() {
    const quoteID = readCookie('meir-au.myshopify.comquote.id') || "";
    const data = await $.ajax({
      url: GRFQConfigs.app_url + '/numitem',
      type: 'GET',
      dataType: 'jsonp',
      data: `&quote_id=${quoteID}`
    });
    return data;
  }

  function displayNumberOfQuote() {
    getDataOfQuote().then(data => {
      if(data && data.numberofenquiry > 0) {
        $('.site-header-link-rfq').addClass('active');
        $('.site-header-link-rfq-quantity').text(data.numberofenquiry);
      } else {
        $('.site-header-link-rfq').removeClass('active');
        $('.site-header-link-rfq-quantity').text(0);
      }
    });
  }

  function handleRequestForQuoteDrawer() {
    const $html = $('html');
    $('.vt-container .vt-col.top-center').on('DOMSubtreeModified', function() {
      if($(this).html()) {
        getDataOfQuote().then(data => {
          if(data) {
            if (data.numberofenquiry == 1) {
              $html.toggleClass('js-rqf-open-right');
              $html.removeClass('js-drawer-open-right');
            }

            if (data.numberofenquiry > 0) {
              $('.site-header-link-rfq').addClass('active');
              $('.site-header-link-rfq-quantity').text(data.numberofenquiry);
            }
          }
        });
      }
    });

    $('.js-close-rfq-drawer').on('click', function() {
      $html.removeClass('js-rqf-open-right');
      $html.removeClass('js-drawer-open-right');
      location.reload();
    });

    $(document).on('click', function(e) {
      var container = $('.cart-drawer');
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $html.removeClass('js-rqf-open-right');
      }
    });
  }

  $(document).ready(function() {
    handleAfterSubmit();
    updateSubmitBtnText();
    handleRequestForQuoteDrawer();
    displayNumberOfQuote();

    $(document).on('click', '.rfq_form_page .minus-qty, .rfq_form_page .plus-qty, .rfq_form_page .item_remove svg', function(e) {
      console.log(this);
      setTimeout(displayNumberOfQuote, 1000);
    });

    setTimeout(function() {
      handleGSTPriceRFQPage();
      buildListHtml();
      handleChangeSelect();
    }, 2500);
  });

})();
